export default {
  crossline: {
    crossline: {
      path: {
        updating: function updating(a) {
          var b = a.attr.path;
          return [{
            initialAttr: {
              path: a.el.attr('path')
            },
            finalAttr: {
              path: b
            }
          }];
        }
      }
    }
  }
};